import React, { useState, useEffect } from "react";
import Banner from "../../components/banner";
import NewsTicker from "../../components/newsTicker";
import DreamCar from "../../components/dreamCar";
import FeaturedCars from "./featuredCars";
import ImageCarousel from "../../components/slider";
import Typography from "@mui/material/Typography";
import ElectricCarIcon from "@mui/icons-material/ElectricCar";
import img from "../../assets/images/text-slider-vec.svg";
import img2 from "../../assets/images/company-logo-01.png";

import Button from "@mui/material/Button";
import { customWhite, green } from "../../constants/colors";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CustomModal from "../../components/customModal";
import CustomForm from "../../components/customForm";
import innerBannerBg from "../../assets/images/inner-banner-img.e9932cd0.png";
import RecentLaunchedCars from "./recentLaunchedCars";
import UpComingCars from "./upcomingCars";
import TrustedPartner from "../singleBrandcategory/trustedPartners";
import styled from "styled-components";
import ReviewsSlider from "../singleBrandcategory/reviewsSlider";
import Header from "../carDetails/header";
import CompareCar from "../../components/compareCar/compareCar";
import axios from "axios";
import { baseUrl } from "../../utills";
import { useGeneralInfo } from "../../context/generalContext";

const Title = styled.p`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
  position: relative;
  padding-left: 20px;
  &::before {
    content: "";
    position: absolute;
    right: 0;
    top: 55%;
    transform: translateY(-50%);
    width: 84%; /* Adjust this value to control the length of the line */
    height: 1px; /* Adjust this value to control the thickness of the line */
    background-color: lightgray;
  }
`;
const LandingPage = () => {
  const user_id = localStorage.getItem("user_id");

  const [openModal, setOpenModal] = React.useState(false);
  // console.log("token", localStorage.getItem("access_token"));
  const token = localStorage.getItem("access_token");
  const [generalInfo, setGeneralInfo] = useGeneralInfo();

  const items = [
    { key: "TO GET YOUR DREAM CAR", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    { key: "234500 USED CARS AVAILABLE", img: <img src={img} alt="" /> },
    { key: "TO GET YOUR DREAM CARS", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    { key: "234500 USED CARS AVAILABLE", img: <img src={img} alt="" /> },
    { key: "TO GET YOUR DREAM CARS", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    { key: "234500 USED CARS AVAILABLE", img: <img src={img} alt="" /> },
    { key: "TO GET YOUR DREAM CARS", img: <img src={img} alt="" /> },
    { key: "GET 30% OFFER ON TOYOTA CAR", img: <img src={img} alt="" /> },
    { key: "234500 USED CARS AVAILABLE", img: <img src={img} alt="" /> },
    // add more items as needed
  ];

  const handleLoop = () => {
    // console.log("Animation loop completed");
  };

 
  const fetchCarPosts = async () => {
    const payload ={
      user_id: Number(user_id),
    }
    try {
      const res = await axios.post(
        baseUrl + "car-posts/filter",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setGeneralInfo((prevInfo) => ({
          ...prevInfo,
          cars: res?.data,
        }));
      } else {
      }
    } catch (error) {
      console.log("Error::", error);
    }
  };
  useEffect(() => {
    fetchCarPosts();
  }, []);
  return (
    <div style={{ height: "auto" }}>
      <CustomModal
        title="Sell Your Car"
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <CustomForm setOpenModal={setOpenModal} />
      </CustomModal>
      <Banner />
      <NewsTicker items={items} handleLoop={handleLoop} />
      <DreamCar />
      <FeaturedCars fetchCarPosts={fetchCarPosts} />
      <div
        className="my-6 md:my-10 lg:my-20 bg-cover bg-no-repeat py-[100px] px-[20px] md:ps-[50px] lg:ps-[110px]"
        style={{
          backgroundImage: `linear-gradient(90deg, #000, transparent), url(${innerBannerBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-white font-bold text-[40px]">
          Confusion, Which is Best Car?
        </h1>
        <p className="text-white mb-10">
          Car servicing is the regular maintenance and inspection of a vehicle
          to ensure that it is <br /> operating safely and efficiently.
        </p>
        <Button
          onClick={() => setOpenModal(true)}
          sx={{
            color: customWhite,
            background: green,
            borderColor: green,
            textTransform: "capitalize",
            padding: "13px 30px",
            ":hover": {
              background: "#0c0d0c",
              borderColor: green,
              color: "white",
            },
          }}
          variant="outlined"
          startIcon={<ElectricCarIcon />}
        >
          Sell Your Car
        </Button>
      </div>
      {/* <div className="mb-20">
        <RecentLaunchedCars />
      </div> */}
      {/* <div className="mb-20">
        <UpComingCars />
      </div> */}

      {/* <div className="mt-30 lg:w-[85%] m-auto mb-[110px] hidden lg:block">
        <div className=" mb-10">
          <Title>Our Trusted Partners</Title>
        </div>
        <div className="ps-4 text-[20px] font-[500] lg:hidden mb-10">
          <p>Our Trusted Partners</p>
        </div>
        <TrustedPartner items={items2} handleLoop={handleLoop} />
      </div> */}

      <CompareCar />

      {/* <div className="mt-30 w-[96%] lg:w-[85%] m-auto mb-[110px]">
        <div className="mb-20 lg:mb-10">
          <p className="text-[40px] font-bold">Our Customer Reviews</p>
          <p>Here are some of the featured cars in different categories</p>
        </div>
        <ReviewsSlider landing="true" />
      </div> */}
    </div>
  );
};

export default LandingPage;
